import getGraphQlClient from '~graphql/getGraphQlClient';
import { onErrorShowMessage } from '~src/errors';
import { unmarshalGraphqlEdges } from '~graphql/utils';
import { FETCH_CLOTHES } from '../queries/clothes';

async function fetchClothes({ forceFetch = false, gender, limit }) {
  try {
    const graphQlClient = await getGraphQlClient();

    const whereClause = {
      gender: {
        equalTo: gender,
      },
    };

    const response = await graphQlClient.query({
      fetchPolicy: forceFetch ? 'network-only' : 'cache-first',
      query: FETCH_CLOTHES,
      variables: {
        where: whereClause,
        limit,
      },
    });

    return unmarshalGraphqlEdges(response.data.editor_cloths).edges;
  } catch (error) {
    onErrorShowMessage();
    console.error(error);
  }
}

export default fetchClothes;
